import { Competition } from '@/redux/competition'

export enum CompetitionStatus {
  Inactive = 'Inactive',
  OnProgress = 'In Progress',
  Cancelled = 'Cancelled',
  Ended = 'Ended',
}

export const getCompetitionStatus = ({
  applyStartAt,
  rewardAt,
}: Competition): CompetitionStatus => {
  const now = Date.now()
  if (now <= applyStartAt) return CompetitionStatus.Inactive
  if (now > applyStartAt && now < rewardAt) return CompetitionStatus.OnProgress
  if (now >= rewardAt) return CompetitionStatus.Ended
  return CompetitionStatus.Inactive
}

export const getIsInApplicationDuration = ({
  applyStartAt,
  applyEndAt,
}:  Competition) => {
  const now = Date.now()
  return now >= applyStartAt && now <= applyEndAt
}
